import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../../../api/client";

// POST /api/v1/plannings/{id}/attendance/ { student, status } → upsert.
// The teacher marks a student present/absent; the backend creates or updates
// the PlanningAssistance for (plan, student).
function useMarkAttendance(planningId) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data) =>
      apiClient
        .post(`/api/v1/plannings/${planningId}/attendance/`, data)
        .then((r) => r.data),
    onSuccess: () =>
      qc.invalidateQueries({ queryKey: ["plannings", planningId, "roster"] }),
  });
}

// Same upsert endpoint — kept as a separate export for callers that "update".
function useUpdateAttendance(planningId) {
  return useMarkAttendance(planningId);
}

export { useMarkAttendance, useUpdateAttendance };
